<div class="authorize-container">
    @if (isLoading()) {
        <div class="loading">
            <p>Loading authorization URL...</p>
        </div>
    }

    @if (error()) {
        <div class="error">
            <p>Error: {{ error() }}</p>
        </div>
    }

    @if (securemeLink() && !isLoading()) {
        <div class="redirecting">
            <p>Redirecting to secure link...</p>
        </div>
    }
</div>

